import { UIParagraphFormatSpec } from '../lib/ui/style';

export type UIParagraphFormat = 'normal' | 'text' | 'title' | 'heading' | 'subtitle' | 'events-title' | 'info' | 'bigtitle' | 'small' | 'narrow' | 'hero-title' | 'signup-title' | 'event-title' | 'input-hint' | 'subheading' | 'email-text' | 'email-info' | 'email-title' | 'email-heading' | 'screen-title' | 'screen-mobile-title' | 'new-hero-title' | 'new-title' | 'new-subtitle' | 'new-heading' | 'new-subheading' | 'new-info' | 'new-bubble';

export const $formats: Record<UIParagraphFormat, UIParagraphFormatSpec> = {
    normal: {
        name: 'Normal'
    },
    text: {
        name: 'Text',
        classes: 'p-f-text b b-text',
    },
    small: {
        name: 'Small',
        classes: 'p-f-small b b-content',
        text: { c: 'soft' }
    },
    title: {
        name: 'Title',
        classes: 'p-f-title b b-title',
        text: { w: 'bold' }
    },
    'screen-title': {
        name: 'Screen title',
        classes: 'p-f-screen-title b b-title',
        text: { w: 'bold' }
    },
    'screen-mobile-title': {
        name: 'Screen mobile title',
        classes: 'p-f-screen-mobile-title b',
        text: { w: 'bold' }
    },
    heading: {
        name: 'Heading',
        classes: 'p-f-heading b b-subtitle',
        text: { w: 'bold' }
    },
    subheading: {
        name: 'Subheading',
        classes: 'p-f-subheading b b-subtitle',
        text: { w: 'bold' }
    },
    subtitle: {
        name: 'Subtitle',
        classes: 'p-f-subtitle b b-subtitle',
        text: { w: 'bold', c: 'tint' }
    },
    'events-title': {
        name: 'Events title',
        classes: 'p-f-events-title b b-title',
    },
    info: {
        name: 'Info',
        classes: 'p-f-info b b-text'
    },
    bigtitle: {
        name: 'Big title',
        classes: 'p-f-bigtitle b b-title',
        text: { w: 'bold', c: 'tint' }
    },
    'event-title': {
        name: 'Event title',
        classes: 'p-f-event-title',
        text: { w: 'bold' }
    },
    'input-hint': {
        name: 'Input hint',
        classes: 'p-f-input-hint b'
    },
    narrow: {
        name: 'Narrow',
        classes: 'p-f-narrow b b-text'
    },
    'signup-title': {
        name: 'Signup title',
        classes: 'p-f-signup-title b b-title',
        text: { w: 'bold' }
    },
    'hero-title': {
        name: 'Hero title',
        classes: 'p-f-hero-title b b-subtitle',
        text: { w: 'bold' }
    },
    'email-text': {
        name: 'Text',
        classes: 'p-f-email-text b-tl-email',
    },
    'email-info': {
        name: 'Info',
        classes: 'p-f-email-info b-tl-email'
    },
    'email-title': {
        name: 'Title',
        classes: 'p-f-email-title b-tl-email',
        text: { w: 'bold', c: 'tint' }
    },
    'email-heading': {
        name: 'Heading',
        classes: 'p-f-email-heading b-tl-email',
        text: { w: 'bold' }
    },
    'new-hero-title': {
        name: 'New hero title',
        classes: 'p-f-new-hero-title b b-subtitle',
        text: { w: 'bold' }
    },
    'new-title': {
        name: 'New title',
        classes: 'p-f-new-title b b-title',
        text: { w: 'bold' }
    },
    'new-subtitle': {
        name: 'New subtitle',
        classes: 'p-f-new-subtitle b b-subtitle',
        text: { w: 'bold' }
    },
    'new-heading': {
        name: 'New heading',
        classes: 'p-f-new-heading b b-title',
        text: { w: 'bold' }
    },
    'new-subheading': {
        name: 'New subheading',
        classes: 'p-f-new-subheading b b-subtitle',
        text: { w: 'bold' }
    },
    'new-info': {
        name: 'New info',
        classes: 'p-f-new-info b b-text'
    },
    'new-bubble': {
        name: 'New bubble',
        classes: 'p-f-new-bubble b b-text'
    }
};
